module.exports = __webpack_public_path__ + "img/Sign-icon.12c6c3dc.png";